.rule_entry {
    border: 1px solid black;
    padding: 5px;
    margin: 5px;
    border-radius: 10px;
}
